import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    pisLoading : false,
    subproducts: [],
    subproducts2: [],
    totalSubProduct: 0,
    numOfPages: 1,
    page: 1,
    imagemessage:"",
    stats: {},
    monthlyApplications: [],
    piscLoading:false,
    pcstatus:"",
    pcMessage:"",
    pdetails:{},
    pismloading:false,
    pmstatus:"",
    pmmessage:"",
    pSDetails: {},
    pdstatus:"",
    pidstatus:"",
    pdmessage:"",
    pidmessage:"",
    spidmessage:"",
    error:"",
    SubProductId:"",
    subproductimageall: [],
  
    
};


const SubProductslice = createSlice({
    name: "subproductList",
    initialState,
    reducers:{
        getSubProductPending: (state) => {
            state.pisLoading = true;
        },
        getSubProductSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.subproducts = payload;
           // console.log(payload);
           // state.user="slice userData";
            state.error = '';
        },
        getSubProductFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },

        getMainSubProductPending: (state) => {
            state.pisLoading = true;
        },
        getMainSubProductSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.subproducts2 = payload;
           // console.log(payload);
           // state.user="slice userData";
            state.error = '';
        },
        getMainSubProductFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },

 

 
  
        createSubProductPending:(state,action) => {
            state.piscLoading=true;
        }, 
        createSubProductSuccess:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="success";
            state.pcMessage="Basic Details Added Successfully";
            state.SubProductId= payload;
            
        },
        createSubProductFail:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="fail";
            //console.log('slice '+payload);
            state.pcMessage=payload;
        },
        getSSubProductPending: (state) => {
            state.pisLoading = true;
        },
        getSSubProductSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.pSDetails=payload;
            // state.SubProducts=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSSubProductFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },


       
        modifySubProductPending:(state,action) => {
            state.pismloading=true;
            state.pmstatus="";
        },
        modifySubProductSuccess:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="success";
           
            state.pmmessage="SubProduct Successfully Updated";
        },
        modifySubProductFail:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="fail";
           // console.log('slice '+payload);
            state.pmmessage=payload;
        },

        getSubProductImagePending: (state) => {
            state.pisLoading = true;
        },
        getSubProductImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.subproductimageall = payload;
           // console.log(payload);
           // state.user="slice userData";
            state.error = '';
        },
        getSubProductImageFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },


       
        deleteSubProductPending:(state,action) => {
            state.pisLoading=true;
            state.pdstatus="";
        },
        deleteSubProductSuccess:(state,{payload}) => {
            state.pisLoading=false;
            state.pdstatus="success";
            state.pdmessage="SubProduct Successfully Deleted";
        },
        deleteSubProductFail:(state,{payload}) => {
            state.pisLoading=false;
            state.pdstatus="fail";
           // console.log('slice '+payload);
            state.pdmessage=payload;
        },

        deleteSubProductImagePending:(state,action) => {
            state.pisLoading=true;
            state.pidstatus="";
        },
        deleteSubProductImageSuccess:(state,{payload}) => {
            state.pisLoading=false;
            state.pidstatus="success";
            state.pidmessage="Product Successfully Deleted";
        },
        deleteSubProductImageFail:(state,{payload}) => {
            state.pisLoading=false;
            state.pidstatus="fail";
           // console.log('slice '+payload);
            state.pidmessage=payload;
        },


      

        reset: (state) => {

            state.piscLoading=false;
            state.pcstatus="false";
            state.pcMessage="";
            state.SubProductId= "";
        },
        imageUploadSuccess:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="success";
            state.pcMessage=payload.message;
            
        },
        imageUploadFailure:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="fail";
            state.pcMessage=payload.message;
            
        },
        
        getSSubProductImagePending: (state) => {
            state.pisLoading = true;
        },
        getSSubProductImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.productsImage=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSSubProductImageFail: (state, action ) => {
      
            state.pisLoading = false;
            state.error = action;
            state.imagemessage = action;
            // console.log("action11",action)
        },
        modifySubProductImagePending:(state,action) => {
            state.pismloading=true;
            state.pmstatus="";
        },
        modifySubProductImageSuccess:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="success";
           
            state.pmmessage="Sub Product Successfully Updated";
        },
        modifySubProductImageFail:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="fail";
           // console.log('slice '+payload);
            state.pmmessage=payload;
        },
      
    },
});

const { reducer, actions } = SubProductslice;

export const { getSubProductPending, getSubProductSuccess,getSubProductFail,getSSubProductPending, getSSubProductSuccess, getSSubProductFail, 
    createSubProductPending, createSubProductSuccess, createSubProductFail,
    modifySubProductPending,modifySubProductSuccess,modifySubProductFail,
    deleteSubProductPending,deleteSubProductSuccess,deleteSubProductFail,reset,getMainSubProductPending, getMainSubProductSuccess,getMainSubProductFail,deleteSubProductImageFail,deleteSubProductImagePending,deleteSubProductImageSuccess,imageUploadFailure,imageUploadSuccess,getSubProductImageFail,getSubProductImagePending,getSubProductImageSuccess,getSSubProductImageFail,getSSubProductImagePending,getSSubProductImageSuccess,modifySubProductImageFail,modifySubProductImagePending,modifySubProductImageSuccess} = actions;

export default reducer;
